class Edge {
  store;
  id;
  vertexId1;
  vertexId2;


  constructor(store, id, vertexId1, vertexId2) {
    this.store = store;
    this.id = id;
    this.vertexId1 = vertexId1;

    this.vertexId2 = vertexId2;
  }

  static fromJSON(store, json) {
    let { id, vertexId1, vertexId2} = json;
    return new Edge(store, id, vertexId1, vertexId2);
  }
}

export default Edge;
